var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-info" }, [
    _c("div", { staticClass: "row title" }, [
      _c(
        "div",
        {
          staticClass: "comp-menu",
          class: { "comp-menu--half-width": !_vm.withDropdown },
        },
        [
          _vm.withDropdown
            ? _c("DottedDropdown", { attrs: { id: "dir-comp-" + _vm.id } }, [
                _c(
                  "li",
                  [
                    _c(
                      "DialogSlot",
                      {
                        ref: _vm.deleteModalId,
                        attrs: {
                          id: _vm.deleteModalId,
                          modalBtnClass: "btn--transparent",
                          modalBtn: _vm.$t("action.delete"),
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "slot-content",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("span", { staticClass: "font-bold" }, [
                              _vm._v(_vm._s(_vm.$t("deleteConfirmMsg"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "buttons" }, slot: "buttons" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn--orange close-reveal-modal",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.index > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "dot-option-btn",
                            on: { click: _vm.moveUp },
                          },
                          [_vm._v(_vm._s(_vm.$t("directory.moveUp")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.index < _vm.lengthOfArray - 1
                      ? _c(
                          "a",
                          {
                            staticClass: "dot-option-btn",
                            on: { click: _vm.moveDown },
                          },
                          [_vm._v(_vm._s(_vm.$t("directory.moveDown")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("label", [
        _vm._v(
          _vm._s(_vm.title) + " " + _vm._s(_vm.showIndex ? _vm.index + 1 : "")
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "info" },
      [
        _c("InputField", {
          attrs: {
            label: _vm.labelEnName,
            showFlag: true,
            showColon: false,
            value: _vm.detail.engName,
            required: true,
            readonlyAsInput: !_vm.canCompInfoEditable,
          },
          on: {
            updateValue: function (val) {
              return _vm._updateField("engName", val)
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "emphasis" }, [
          _vm._v(_vm._s(_vm.labelChiName)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row chinese-name" },
          [
            _vm.isEngineer
              ? _c("label", [
                  _vm._v(_vm._s(_vm.$t("directory.label.traditionalChinese"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("InputField", {
              staticClass: "small-12 large-12",
              attrs: {
                showFlag: false,
                showColon: false,
                value: _vm.detail.chtName,
                readonlyAsInput: !_vm.canCompInfoEditable,
              },
              on: { updateValue: _vm.updateChtAndClearChs },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isSimplifiedChineseShow
          ? _c(
              "div",
              { staticClass: "row chinese-name" },
              [
                _vm.isEngineer
                  ? _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("directory.label.simplifiedChinese")) +
                          "\n        "
                      ),
                      _vm.isPencilEdit && _vm.currentPencilEdit !== "chsName"
                        ? _c("i", {
                            staticClass: "fa fa-pencil fa-lg icon edit-field",
                            on: {
                              click: function ($event) {
                                return _vm.enablePencilEdit("chsName")
                              },
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPencilEdit && _vm.currentPencilEdit === "chsName"
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--orange save-btn-link",
                        attrs: { type: "button" },
                        on: { click: _vm.saveDirectory },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.save")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showTranslatorBtn
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--darkblue translator-btn-link",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.disableTranslatorBtn &&
                            _vm.currentPencilEdit !== "chsName",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.translateToSimpleChi(_vm.detail.chtName)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("directory.hint.chinese")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("InputField", {
                  ref: "chsName-input",
                  staticClass: "small-12 large-12",
                  attrs: {
                    showFlag: false,
                    showColon: false,
                    value: _vm.detail.chsName,
                    readonlyAsInput:
                      !_vm.isSimplifiedChineseEditable &&
                      _vm.currentPencilEdit !== "chsName",
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm._updateField("chsName", val)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !(_vm.isFloorDR || _vm.isDetail)
          ? _c("InputField", {
              attrs: {
                label:
                  _vm.$t("directory.label.floor") +
                  " " +
                  _vm.$t("directory.label.floorExample"),
                showFlag: false,
                showColon: false,
                value: _vm.detail.floor,
                required: false,
                readonlyAsInput: !_vm.canCompInfoEditable,
              },
              on: {
                updateValue: function (val) {
                  return _vm._updateField("floor", val)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isEngineer && !(_vm.isFloorDR || _vm.isDetail)
          ? _c(
              "div",
              { staticClass: "row premise" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("directory.label.premisesAtTerminal")) +
                      "\n        "
                  ),
                  _vm.isPencilEdit &&
                  _vm.currentPencilEdit !== "premisesAtTerminal"
                    ? _c("i", {
                        staticClass: "fa fa-pencil fa-lg icon edit-field",
                        on: {
                          click: function ($event) {
                            return _vm.enablePencilEdit("premisesAtTerminal")
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.isPencilEdit &&
                _vm.currentPencilEdit === "premisesAtTerminal"
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--orange save-btn-link",
                        attrs: { type: "button" },
                        on: { click: _vm.saveDirectory },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.save")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("InputField", {
                  ref: "premisesAtTerminal-input",
                  staticClass: "small-12 large-12",
                  attrs: {
                    showFlag: false,
                    showColon: false,
                    value: _vm.detail.premisesAtTerminal,
                    required: false,
                    readonlyAsInput:
                      !_vm.canCompInfoEditable &&
                      _vm.currentPencilEdit !== "premisesAtTerminal",
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm._updateField("premisesAtTerminal", val)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isFloorDR && !_vm.isDetail
          ? _c(
              "div",
              { staticClass: "row premise" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("directory.label.premises")) + "\n        "
                  ),
                  _vm.isPencilEdit && _vm.currentPencilEdit !== "premises"
                    ? _c("i", {
                        staticClass: "fa fa-pencil fa-lg icon edit-field",
                        on: {
                          click: function ($event) {
                            return _vm.enablePencilEdit("premises")
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.isPencilEdit && _vm.currentPencilEdit === "premises"
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--orange save-btn-link",
                        attrs: { type: "button" },
                        on: { click: _vm.saveDirectory },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.save")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("InputField", {
                  ref: "premises-input",
                  staticClass: "small-12 large-12",
                  attrs: {
                    showFlag: _vm.isFloorDR && !_vm.isSub,
                    showColon: false,
                    value: _vm.detail.premises,
                    required: _vm.isFloorDR && !_vm.isSub,
                    readonlyAsInput:
                      !_vm.canCompInfoEditable &&
                      _vm.currentPencilEdit !== "premises",
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm._updateField("premises", val)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }